import { render, staticRenderFns } from "./FooterLogo.vue?vue&type=template&id=ffad0a7e&scoped=true&"
import script from "./FooterLogo.vue?vue&type=script&lang=js&"
export * from "./FooterLogo.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogo.vue?vue&type=style&index=0&id=ffad0a7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffad0a7e",
  null
  
)

export default component.exports